import React from "react";

export default function FormHeader({
  icon,
  title,
  description,
}: {
  icon: React.ReactNode;
  title: string;
  description?: string;
}) {
  return (
    <div className="mb-5 flex gap-5">
      <div className="mt-1">{icon}</div>
      <section>
        <h1 className="font-bold">{title}</h1>
        <p className="text-muted-foreground text-pretty">{description}</p>
      </section>
    </div>
  );
}
